import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elRoundimage from './images/MintButtom_elRoundimage_718961.png';

export default class MintButtom extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const style_elRoundimage = {
      backgroundImage: 'url('+img_elRoundimage+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
     };
    
    const style_elButton = {
      display: 'block',
      fontSize: 30.0,
      color: '(null)',
      textAlign: 'center',
      backgroundColor: 'transparent',
     };
    const style_elTextBlock = {
      color: '#f3fffd',
      textAlign: 'center',
     };
    
    return (
      <div className="MintButtom">
        <div className="layoutFlow">
          <div className="elRoundimage">
            <div style={style_elRoundimage} />
          </div>
          
          <div className="flowRow flowRow_MintButtom_elButton_101977">
          <div className="elButton">
            <button className="font-caesarDressingRegular" style={style_elButton}>
              {this.context.locStrings.component1_button_101977}
            </button>
          </div>
          
          </div>
        </div>
        
        <div className="foreground">
          <div className="headlineFont elTextBlock" style={style_elTextBlock}>
            <div>{this.context.locStrings.mint_buttom_textblock_392574}</div>
          </div>
        </div>
      </div>
    )
  }
  
}
